export const AuthorNote = () => {
  return (
    <section className="py-24 bg-void relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-blood/5 via-transparent to-blood/5" />
      
      <div className="container mx-auto px-4 relative z-10 max-w-4xl">
        <div className="border-l-4 border-blood pl-8 py-8 bg-card/10 backdrop-blur-sm">
          <h2 className="text-4xl md:text-5xl font-black mb-6 tracking-tight">
            <span className="text-blood-bright">A Note From The Author</span>
          </h2>
          
          <div className="space-y-6 text-lg md:text-xl leading-relaxed">
            <p className="text-foreground">
              I didn't write this book to make you feel good.
            </p>
            
            <p className="text-foreground">
              I wrote it because I'm tired of watching people with potential die slow deaths of comfort, distraction, and broken promises.
            </p>
            
            <p className="text-steel">
              I spent years studying the most disciplined people on Earth,  monks who wake at 4AM and live in silence, convicts who transformed concrete cells into mental fortresses, and millionaires who treat their minds like weapons.
            </p>
            
            <p className="text-steel">
              What I found wasn't inspiration. It was <span className="text-blood-bright font-semibold">warfare</span>.
            </p>
            
            <p className="text-foreground">
              Discipline isn't built with affirmations and vision boards. It's forged in shame, pain, and brutal honesty. The rituals in this book are not gentle. They're not designed to make you comfortable. They're designed to <span className="text-blood-bright font-bold">kill the weak version of you</span> so something stronger can take its place.
            </p>
            
            <p className="text-steel">
              Most people will read the first chapter and quit. They'll say it's "too harsh" or "too extreme." Good. This book isn't for them. It's for the ones who are tired of being average. Tired of negotiating with themselves. Tired of waking up ashamed.
            </p>
            
            <p className="text-foreground font-semibold">
              If you're one of them, you already know what you need to do.
            </p>
            
            <p className="text-foreground font-semibold">
              Stop reading. Start executing.
            </p>
            
            <div className="mt-8 pt-8 border-t border-smoke">
              <p className="text-steel text-base italic">
                This book will not motivate you. It will not inspire you. It will not comfort you.
              </p>
              <p className="text-blood-bright text-xl font-bold mt-4 uppercase tracking-wider">
                It will execute you.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-ash text-sm italic">
           ,  The Discipline Bible is not for public consumption. Limited first edition. No reprints.
          </p>
        </div>
      </div>
    </section>
  );
};
